import { render } from "./HomeProdutos.vue?vue&type=template&id=63dbf046&scoped=true"
import script from "./HomeProdutos.vue?vue&type=script&lang=js"
export * from "./HomeProdutos.vue?vue&type=script&lang=js"

import "./HomeProdutos.vue?vue&type=style&index=0&id=63dbf046&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63dbf046"]])

export default __exports__